import { Step, StepObject } from '../../types';

export const generateDefaultStepsFromConfig = (steps: Step[]): StepObject[] => {
  return steps.map((step) => ({
    name: step,
    finished: false,
  }));
};
